import { SidebarMenuItem } from "@/components/ui/sidebar";
import { motion } from "framer-motion";
import { ReactNode } from "react";

export const MenuItemWrapper = ({
  animateLayout = false,
  layoutDependency,
  children,
}: {
  animateLayout?: boolean;
  layoutDependency?: string;
  children: ReactNode;
}) => {
  if (!animateLayout) {
    return <SidebarMenuItem>{children}</SidebarMenuItem>;
  }

  return (
    <motion.li
      layout="position"
      layoutDependency={layoutDependency}
      transition={{ type: "spring", stiffness: 500, damping: 40 }}
      data-slot="sidebar-menu-item"
      data-sidebar="menu-item"
      className="group/menu-item relative"
    >
      {children}
    </motion.li>
  );
};
